import { NavLink, useLocation } from 'react-router-dom'
import { cn } from '@/lib/utils'

/**
 * SubNav — pill-strip die je op module-hubs plaatst om naar sub-pages te linken.
 * Gebruikt door: Kempenvision hub, Image Compo hub, Tournaments hub, ...
 *
 * Props:
 *   items: [{ to, label, icon?: Component, adminOnly?, hidden? }]
 *   isAdmin: boolean — of admin-only items getoond mogen worden
 *
 * Rendering: horizontale scroll-strip met kabinet-pills. Actieve link = acid border-left.
 */
export default function SubNav({ items, isAdmin = false }) {
  const location = useLocation()
  const visible = items.filter(i => !i.hidden && (!i.adminOnly || isAdmin))
  if (visible.length === 0) return null

  return (
    <nav className="flex items-center gap-1 overflow-x-auto -mx-2 px-2 pb-1">
      {visible.map(item => {
        const Icon = item.icon
        const active = location.pathname === item.to
        return (
          <NavLink
            key={item.to}
            to={item.to}
            className={cn(
              'inline-flex items-center gap-2 px-3 py-1.5 rounded-[4px] border text-sm shrink-0 transition-colors',
              'border-l-2',
              active
                ? 'bg-acid/8 text-acid border-acid border-l-acid'
                : 'bg-card border-border text-muted-foreground hover:text-foreground hover:border-acid/40 border-l-transparent'
            )}
          >
            {Icon && <Icon className="h-3.5 w-3.5" />}
            <span>{item.label}</span>
            {item.adminOnly && (
              <span className="font-mono text-[9px] uppercase tracking-widest opacity-60">admin</span>
            )}
          </NavLink>
        )
      })}
    </nav>
  )
}
